import { getMessageDate } from "../components/MessageHistory/timelineUtils";
import {
  isInternalNoteType,
  isLogType,
  isClientMessage,
  getClientCommunicationChannelKey,
  getClientCommunicationChannelLabel,
} from "../components/MessageHistory/messageTypeRegistry";

export const deriveConversationContext = (messages = []) => {
  const list = Array.isArray(messages) ? messages : [];
  const clientChannelsByKey = new Map();
  let lastClientMessage = null;
  let lastTransferLog = null;
  const recentNotes = [];
  let isGroup = false;

  list.forEach((msg) => {
    const channelKey = getClientCommunicationChannelKey(msg);
    if (channelKey) {
      const label = getClientCommunicationChannelLabel(msg);
      if (label && !clientChannelsByKey.has(channelKey)) {
        clientChannelsByKey.set(channelKey, label);
      }
    }
    if (msg?.isGroupMessage || msg?.group?.id) isGroup = true;

    if (isClientMessage(msg)) {
      const d = getMessageDate(msg);
      if (!lastClientMessage || (d && getMessageDate(lastClientMessage) && d > getMessageDate(lastClientMessage))) {
        lastClientMessage = msg;
      }
    }

    if (isLogType(msg)) {
      const plain = (msg?.textPlain || msg?.text || "").replace(/<[^>]*>/g, "");
      if (/transfer/i.test(plain)) lastTransferLog = msg;
    }

    if (isInternalNoteType(msg)) {
      recentNotes.push(msg);
    }
  });

  recentNotes.sort((a, b) => {
    const da = getMessageDate(a);
    const db = getMessageDate(b);
    if (da && db) return db - da;
    return 0;
  });

  return {
    channelCount: clientChannelsByKey.size,
    channels: [...clientChannelsByKey.values()],
    lastClientMessage,
    lastTransferLog,
    recentNotes: recentNotes.slice(0, 3),
    isGroup,
  };
};

export const formatRelativeTime = (date) => {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return "";
  const diffMs = Date.now() - d.getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "agora";
  if (mins < 60) return `há ${mins} min`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `há ${hours}h`;
  const days = Math.floor(hours / 24);
  return `há ${days} dia${days > 1 ? "s" : ""}`;
};
